import React from "react";
import BillingDetailSection from "features/billings/sections/BillingDetailSection";
import Header from "features/shared/layout/header/Header";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getInvoiceDetailRoute } from "features/shared/helpers/routeHelper";
import { useSearchParams } from "features/shared/hooks/useSearchParams";
import { containsFuelingParam } from "features/shared/helpers/queryParams";

interface Props {
  billingId: string;
  invoiceId: string;
}

const BillingDetail = (props: Props) => {
  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  // router
  const { billingId, invoiceId } = useParams<Props>();
  const searchParams = useSearchParams();

  return (
    <>
      <Header
        title={t("billingDetail.title")}
        includeBreadcrumbs
        links={[
          { text: t("invoices.title"), to: "/invoices" },
          { text: t("invoiceDetail.title"), to: getInvoiceDetailRoute("Invoice", invoiceId) },
        ]}
      />
      <ModuleContent>
        <BillingDetailSection 
          billingId={billingId} 
          isFueling={containsFuelingParam(searchParams)}
        />
      </ModuleContent>
    </>
  );
};

export default BillingDetail;
